import api from "./api";

class ClaimMonthlyDataService {
  // Dashboard (monthly group rows + counts)
  dashboard(params = {}) {
    return api.get("/claim-monthly/dashboard", { params });
  }

  // List monthly groups (paginated, filtered)
  getAll(params = {}) {
    return api.get("/claim-monthly", { params });
  }

  // Single monthly group with all sections
  get(id) {
    return api.get(`/claim-monthly/${id}`);
  }

  // Adjuster finalizes their month
  finalize(data) {
    return api.post("/claim-monthly/finalize", data);
  }

  // Transition monthly group status (6-step flow)
  updateStatus(id, data) {
    return api.put(`/claim-monthly/${id}/status`, data);
  }

  // Update Section B rows (replace all)
  updateSectionB(id, rows) {
    return api.put(`/claim-monthly/${id}/section-b`, { rows });
  }

  // Update Section C rows (replace all)
  updateSectionC(id, rows) {
    return api.put(`/claim-monthly/${id}/section-c`, { rows });
  }

  // Communication notes
  addNote(id, message) {
    return api.post(`/claim-monthly/${id}/notes`, { message });
  }

  getNotes(id) {
    return api.get(`/claim-monthly/${id}/notes`);
  }

  // Bookkeeping (PAID groups with filters)
  bookkeeping(params = {}) {
    return api.get("/claim-monthly/bookkeeping", { params });
  }

  // Get adjusters, optionally filtered by branch
  getAdjusters(params = {}) {
    return api.get("/claim-monthly/adjusters", { params });
  }

  // Get Final Report data for an adjuster (Section A + B + C)
  getAdjusterReport(params = {}) {
    return api.get("/claim-monthly/adjuster-report", { params });
  }

  // Pending claims summary for reviewer roles
  pendingSummary(params = {}) {
    return api.get("/claim-monthly/pending-summary", { params });
  }

  // Update individual claim fields (delegates to existing claimsV3 endpoint)
  updateClaim(id, data) {
    return api.put(`/claimsV3/${id}`, data);
  }

  // Manual migration trigger (super-admin only)
  migrate(action) {
    return api.post("/claim-monthly/migrate", { action });
  }

  // Preview migration counts
  migratePreview() {
    return api.get("/claim-monthly/migrate?preview=true&_=" + Date.now());
  }

  // Scheduler status for management page
  schedulerStatus() {
    return api.get("/claim-monthly/scheduler-status?_=" + Date.now());
  }

  // Reset scheduler job status (delete from DB)
  resetScheduler() {
    return api.post("/claim-monthly/reset-scheduler");
  }

  // Recover orphaned claims (nullify claimMonthlyId where group is deleted)
  recoverClaims() {
    return api.post("/claim-monthly/recover-claims");
  }

  // ─── File uploads for Section C ──────────────────────────────────────
  uploadAttachment(id, formData) {
    const rowType = formData.get('rowType');
    return api.post(`/claim-monthly/${id}/upload?rowType=${encodeURIComponent(rowType)}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
  getAttachments(id) {
    return api.get(`/claim-monthly/${id}/attachments`);
  }
  deleteAttachment(fileId) {
    return api.delete(`/claim-monthly/attachment/${fileId}`);
  }
  downloadAttachment(fileId) {
    return api.get(`/claim-monthly/attachment/${fileId}/download`, { responseType: 'blob' });
  }
}

export default new ClaimMonthlyDataService();
